<div class="account-history-filter-inner-container">
    <div class="filter-title">Filters</div>

    <div class="filters-wrapper">
        <div class="filter-wrapper">
            <div class="filter-label">type</div>
            <div class="filter-options-wrapper">
                <app-sopo-select-button title="Type" [selectedText]="selectedHistoryType()" [list]="historyTypes"
                    [selected]="selectedHistoryType()" (selectedChange)="onHistoryTypeSelect($event)" [showIcon]="false"
                    [zIndex]="1000" class="select-box gray-box selected">
                </app-sopo-select-button>
            </div>
        </div>
        <div class="filter-wrapper">
            <div class="filter-label">status</div>
            <div class="filter-options-wrapper">
                <div class="gray-box clickable" [class]="{ 'selected': selectedStatus() == 'completed' }"
                    (click)="onStatusSelect('completed')">
                    complete
                </div>
                <div class="gray-box clickable" [class]="{ 'selected': selectedStatus() == 'pending' }"
                    (click)="onStatusSelect('pending')">
                    pending
                </div>
                <div class="gray-box clickable" [class]="{ 'selected': selectedStatus() == 'failed' }"
                    (click)="onStatusSelect('failed')">
                    failed
                </div>
            </div>
        </div>

        <div class="filter-wrapper">
            <div class="filter-label">start date</div>
            <div class="filter-options-wrapper">
                <div class="gray-box" [ngClass]="{
                    'selected': customStartDate()
                }">
                    {{ customStartDate() ? months[customStartDate().month] : "month" }}
                </div>
                <div class="gray-box" [ngClass]="{
                    'selected': customStartDate()
                }">
                    {{ customStartDate() ? customStartDate().day : "day" }}
                </div>
                <div class="gray-box" [ngClass]="{
                    'selected': customStartDate()
                }">
                    {{ customStartDate() ? customStartDate().year : "year" }}
                </div>
                <ion-datetime-button datetime="datetime-start" class="date-filter"></ion-datetime-button>
                <ion-modal [keepContentsMounted]="true">
                    <ng-template>
                        <ion-datetime #startDateSelector [showDefaultButtons]="true" id="datetime-start"
                            [value]="startDate() ? (startDate().toDate() | date:'yyyy-MM-dd') : null"
                            [max]="currentDate.toDate() | date:'yyyy-MM-dd'"
                            (ionChange)="dateChange($event, 'start')"
                            presentation="date"
                            [formatOptions]="dateFormatOptions">
                        </ion-datetime>
                    </ng-template>
                </ion-modal>
            </div>
        </div>

        <div class="filter-wrapper">
            <div class="filter-label">end date</div>
            <div class="filter-options-wrapper">
                <div class="gray-box" [ngClass]="{
                    'selected': customEndDate()
                }">
                    {{ customEndDate() ? months[customEndDate().month] : "month" }}
                </div>
                <div class="gray-box" [ngClass]="{
                    'selected': customEndDate()
                }">
                    {{ customEndDate() ? customEndDate().day : "day" }}
                </div>
                <div class="gray-box" [ngClass]="{
                    'selected': customEndDate()
                }">
                    {{ customEndDate() ? customEndDate().year : "year" }}
                </div>
                <ion-datetime-button datetime="datetime-end" class="date-filter"></ion-datetime-button>
                <ion-modal [keepContentsMounted]="true">
                    <ng-template>
                        <ion-datetime #endDateSelector [showDefaultButtons]="true" id="datetime-end"
                            [value]="endDate() ? (endDate().toDate() | date:'yyyy-MM-dd') : null"
                            [max]="currentDate.toDate() | date:'yyyy-MM-dd'"
                            (ionChange)="dateChange($event, 'end')" presentation="date"
                            [formatOptions]="dateFormatOptions">
                        </ion-datetime>
                    </ng-template>
                </ion-modal>
            </div>
        </div>

        <div class="sopo-popup-button-container buttons-wrapper">
            <div class="sopo-popup-green-button clickable" (click)="applyFilters()">
                APPLY
            </div>
            <div class="sopo-popup-white-button button clickable clear-filters" (click)="clearFilters()">
                CLEAR FILTERS
            </div>
        </div>
    </div>

</div>
